import { render, staticRenderFns } from "./Pribil_toza.vue?vue&type=template&id=6c29f496&scoped=true&"
import script from "./Pribil_toza.vue?vue&type=script&lang=js&"
export * from "./Pribil_toza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c29f496",
  null
  
)

export default component.exports